import React, { useEffect, useState } from 'react'
import { getCookie } from 'utils/cookies'
import useFeatureToggles from 'utils/hooks/use-feature-toggles'
import AccessibilityWidget from 'utils/user-way-accessibility-widget'
import HandTalkWidget from 'utils/hand-talk-widget'

function ResolvedAccessibilityWidgets() {
  const { featureToggles, isLoadingFeatureTogglesData } = useFeatureToggles()

  if (isLoadingFeatureTogglesData) {
    return null
  }

  if (featureToggles.vLibrasEnabled) {
    return <HandTalkWidget />
  }

  return <AccessibilityWidget />
}

export function AccessibilityWidgets() {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    const token = getCookie('access_token')
    return token !== null && token !== ''
  })

  useEffect(() => {
    if (isAuthenticated) {
      return
    }
    const id = setInterval(() => {
      const token = getCookie('access_token')
      if (token) {
        setIsAuthenticated(true)
      }
    }, 1000)
    return () => clearInterval(id)
  }, [isAuthenticated])

  if (!isAuthenticated) {
    return <AccessibilityWidget />
  }

  return <ResolvedAccessibilityWidgets />
}

export default AccessibilityWidgets
